import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { LabelPerfPageLayout } from '~/modules/label-perf/components/LabelPerfPageLayout';

import { DataFreshness } from './containers/DataFreshness/DataFreshness';
import { LabelPerf } from './containers/LabelPerf/LabelPerf';
import { LabelMapping } from './containers/Mapping';
import { GlobalRevenueByVintage } from './containers/Reports/GlobalRevenueByVintage';
import { GlobalStreamsByDsp } from './containers/Reports/GlobalStreamsByDsp';
import { GlobalStreamsByVintage } from './containers/Reports/GlobalStreamsByVintage';
import { ReportsLanding } from './containers/Reports/ReportsLanding';

/**
 * Top-level router combining module-level routers
 */
function Router() {
  return (
    <Suspense>
      <Routes>
        {/* Reports landing page */}
        <Route path="reports" element={<ReportsLanding />} />

        {/* Report pages */}
        <Route
          path="reports/global-streams-by-dsp"
          element={<GlobalStreamsByDsp />}
        />
        <Route
          path="reports/global-streams-by-vintage"
          element={<GlobalStreamsByVintage />}
        />
        <Route
          path="reports/global-revenue-by-vintage"
          element={<GlobalRevenueByVintage />}
        />

        <Route element={<LabelPerfPageLayout />}>
          <Route path="*" element={<LabelPerf />} />
          <Route path="mapping" element={<LabelMapping />} />
          <Route path="data-freshness" element={<DataFreshness />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

Router.displayName = 'LabelPerfRouter';

export { Router };
